module.exports = __webpack_public_path__ + "media/8.5047c20b.mp3";